import Encoding from 'encoding-japanese' // ファイル取込においてファイル形式を判別する際に必要
import Pps from 'papaparse'; // ファイル取込においてCSV形式へ変換する際に必要

import * as _hm from './_hm';
import * as _ht from './_ht';

const $cvtJsonAsync = (
  csv: _ht.o
) => new Promise( _exit => {
  Pps.parse(csv, {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    delimiter: ',',
    transformHeader: (_h: _ht.s) => _h.replace(/\"/g, '').trim(),
    linebreak: '\n',
    complete: (_rz: _ht.dz) => {
      _hm.udtDz(_rz, { // 命名規則を合わせるための言い換え
        ls: _rz.data,
        data: undefined,
      });
      _exit(_rz);
    },
  });
});


export const iptAsync = (pz: {
  mode?: 't' | 'c', // t: text, c: csv
  file: _ht.o,
}) => {
  return new Promise( _exit => {
    const reader = new FileReader();
    reader.readAsBinaryString(pz.file);
    reader.onload = async (_evt: _ht.a) => {
      const _ary = _hm.cvtCharCodes(_evt.target.result);
      const _ecd = Encoding.detect(_ary);
      const _ucd = Encoding.convert(_ary, {
        to: 'unicode',
        from: _ecd,
        type: 'string'
      });
      if (pz.mode == 'c') {
        _exit(await $cvtJsonAsync(_ucd));
      }
      else {
        _exit(_ucd);
      }
    };
  });
};
